// Text with icons: in the theme editor, selecting an item scrolls the phone swipe row to it.
document.addEventListener('shopify:block:select', (event) => {
  const item = event.target.closest('.text-with-icons__item');
  if (!item) return;
  const carousel = item.closest('cs-carousel');
  if (!carousel || typeof carousel.goTo !== 'function') return;
  carousel.goTo([...item.parentElement.children].indexOf(item), false);
});
